// Vendor Libs
import React from 'react';

// Components
import MainHeader from '../layout/main/main-header';
import ResetPasswordForm from './reset-password-form';

const formName = 'resetPassword';

function ResetPassword() {
    return (
        <>
            <MainHeader />
            <ResetPasswordForm formName={formName} />
        </>
    );
}

export default ResetPassword;
